import { DASHBOARD_COLS, DASHBOARD_MARGIN, DASHBOARD_ROW_HEIGHT, } from '@techstack/core';
/**
 * Upper bound of each rung, inclusive, in CSS pixels. `expanded` is everything
 * above `standard` and so has no entry.
 */
export const RUNG_MAX_WIDTH = {
    tile: 219,
    glance: 299,
    standard: 619,
};
export const RUNGS = ['tile', 'glance', 'standard', 'expanded'];
/** Which rung a given rendered width sits on. */
export function rungForWidth(px) {
    if (!(px > 0))
        return 'standard';
    if (px <= RUNG_MAX_WIDTH.tile)
        return 'tile';
    if (px <= RUNG_MAX_WIDTH.glance)
        return 'glance';
    if (px <= RUNG_MAX_WIDTH.standard)
        return 'standard';
    return 'expanded';
}
/**
 * A widget's rendered size in pixels.
 *
 * This is react-grid-layout's own arithmetic, with `containerPadding` at [0,0]
 * as the board sets it. Kept here rather than imported because RGL does not
 * export it, and because a cell's size is a fact about the board's geometry
 * that the board should be able to state without rendering anything.
 */
export function cellPixelSize({ w, h, bp, containerWidth }) {
    const cols = DASHBOARD_COLS[bp];
    const [marginX, marginY] = DASHBOARD_MARGIN;
    const colWidth = (containerWidth - marginX * (cols - 1)) / cols;
    return {
        width: Math.max(0, w * colWidth + (w - 1) * marginX),
        height: Math.max(0, h * DASHBOARD_ROW_HEIGHT + (h - 1) * marginY),
    };
}
/**
 * The rung a widget of this size sits on.
 *
 * Width only, exactly as the stylesheet does it, and for the same reason: the
 * container is `inline-size`, which cannot answer a height query, and
 * `container-type: size` would apply size containment to every widget on the
 * board to serve one rung. A cell that is wide and very short is therefore
 * still on its width's rung — a known limit, named in the stylesheet too.
 */
export function rungForCell(args) {
    if (!(args.containerWidth > 0))
        return 'standard';
    return rungForWidth(cellPixelSize(args).width);
}
